import { riskClass } from '../../utils/format';
export default function RiskBadge({ level }) {
  const labels = { faible: 'Faible', moyen: 'Moyen', 'élevé': 'Élevé' };
  return <span className={`badge ${riskClass(level)}`}>{labels[level] ?? level}</span>;
}
